import ReactECharts from 'echarts-for-react';
import { HTMLAttributes } from 'react';

/**
 * This file should not hold any business logic
 * This file is just to provide types for EChart react components
 * which does not provide TS types yet
 * When you need to enhance the type here, refer this doc
 * https://echarts.apache.org/v4/en/option.html#series-line.type
 */

export const TEChartTypes = [
  'line',
  'bar',
  'pie',
  'scatter',
  'radar',
  'tree',
] as const;

export type TEChartType = typeof TEChartTypes[number];

export type EchartStyle = {
  color?: string;
};

type PositionType =
  | 'left'
  | 'right'
  | 'bottom'
  | 'inside'
  | 'insideLeft'
  | 'insideRight'
  | 'insideTop'
  | 'insideBottom'
  | 'insideTopLeft'
  | 'insideBottomLeft'
  | 'insideTopRight'
  | 'insideBottomRight'
  | [string | number, string | number];

type EChartLabel = {
  show?: boolean;
  position?: PositionType;
  formatter?: string | ((params: unknown) => string);
};

type Tooltip = {
  valueFormatter?: string | ((value: number | string) => string);
};

export type EChartSeries = {
  name?: string;
  stack?: string | null;
  areaStyle?: object | null;
  radius?: string;
  center?: string[];
  data: unknown[];
  type: TEChartType;
  smooth?: boolean;
  itemStyle?: EchartStyle;
  label?: EChartLabel;
  tooltip?: Tooltip;
};

type EChartAxisLabel = {
  formatter?: string | ((value: string, index: number) => string);
  interval?: number;
};

export type EChartOption = {
  legend?: {
    orient?: string;
    type?: string;
    data?: string[];
    show?: boolean;
    animation?: boolean;
    padding?: number[];
    bottom?: number | string;
    right?: number | string;
    left?: number | string;
    top?: number | string;
  };
  series?: EChartSeries[];
  grid?: {
    containLabel: boolean;
    bottom?: number | string;
    top?: number | string;
    right?: number | string;
    left?: number | string;
  };
  xAxis?: {
    type: string;
    data: string[];
    column?: string;
    axisLabel?: EChartAxisLabel;
  };
  yAxis?: {
    name?: string;
    type?: string;
    data?: string[];
    column?: string;
    axisLabel?: EChartAxisLabel;
    min?: number;
  }[];
  tooltip?: {
    trigger?: string;
    axisPointer?: {
      type?: string;
    };
  };
};

export default function EChartV2({
  loading,
  option,
  ...props
}: {
  loading?: boolean;
  option: EChartOption;
} & HTMLAttributes<HTMLDivElement>) {
  return <ReactECharts showLoading={loading} option={option} {...props} />;
}
